// extracted by mini-css-extract-plugin
module.exports = {"gaugeInnerText":"RadialGauge_gaugeInnerText__V3t33","gaugeCenter":"RadialGauge_gaugeCenter__EmgJj"};